import React from "react";
import { useTranslation } from 'react-i18next';
import { ERROR_CODES } from "../../actions/apiClient";
import "./index.css";

const ErrorMessage = (props) => {
    const t = useTranslation()[0];
    const error = props.error || {};
    const code = ERROR_CODES[error.code] ? error.code : ERROR_CODES.UNKNOWN;

    const yes = t("errors.yes");
    const no = t("errors.no");

    const details = [
        { label: t("errors.fields.apiUrl"), value: error.apiUrl },
        { label: t("errors.fields.tenant"), value: props.tenant },
        { label: t("errors.fields.branch"), value: props.branch },
        { label: t("errors.fields.status"), value: error.status },
        { label: t("errors.fields.crossHost"), value: error.crossHost === true ? yes : (error.crossHost === false ? no : undefined) },
        { label: t("errors.fields.online"), value: typeof navigator !== "undefined" ? (navigator.onLine ? yes : no) : undefined },
        { label: t("errors.detailsLabel"), value: error.detail },
    ].filter(d => d.value !== undefined && d.value !== null && d.value !== "");

    return (
        <div className="errorMessage">
            <h1 className="errorMessageTitle">{t(`errors.${code}.title`)}</h1>
            <p className="errorMessageHint">{t(`errors.${code}.hint`)}</p>
            {code === ERROR_CODES.CROSS_HOST_BLOCKED && error.pna &&
                <p className="errorMessageHint">{t("errors.CROSS_HOST_BLOCKED.pnaHint")}</p>
            }
            {details.length > 0 &&
                <dl className="errorMessageDetails">
                    {details.map(d => (
                        <div className="errorMessageDetailRow" key={d.label}>
                            <dt>{d.label}</dt>
                            <dd>{String(d.value)}</dd>
                        </div>
                    ))}
                </dl>
            }
        </div>
    );
};
export default ErrorMessage;
